"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.RelatedTopicsList = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _classnames = _interopRequireDefault(require("classnames"));

var _connectors = require("@insided/shared/services/algolia/connectors");

var _htmlParser = _interopRequireDefault(require("@insided/deprecated-preact-components/utils/htmlParser"));

var getIconClass = function getIconClass(hit) {
  if (hit.has_answer) {
    return 'icon--checkmark qa-icon-answered';
  }

  if (hit.content_type === 'question') {
    return 'icon--question qa-icon-question';
  }

  return null;
};

var RelatedTopicsList = function RelatedTopicsList(props) {
  var hits = props.hits,
      topicId = props.topicId,
      widgetTitle = props.widgetTitle,
      totalItemCount = props.totalItemCount;
  var hitsWithoutCurrent = hits.filter(function (hit) {
    return hit.id !== parseInt(topicId);
  }).slice(0, totalItemCount);

  if (!hitsWithoutCurrent.length) {
    return null;
  }

  return (0, _preact.h)("div", {
    className: (0, _classnames.default)('box__content', 'widget', 'box__pad', 'widget--related-topics')
  }, Boolean(widgetTitle) && (0, _preact.h)("h3", {
    className: "widget-title related-topics__widget-title"
  }, widgetTitle), (0, _preact.h)("ul", {
    className: "simple-topic-list"
  }, hitsWithoutCurrent.map(function (hit, index) {
    var _hit$topic_url;

    var iconClass = getIconClass(hit);
    return (0, _preact.h)("li", {
      key: index,
      className: "related-topics__topic simple-topic-list--item"
    }, (0, _preact.h)("h4", {
      className: (0, _classnames.default)('h6', 'related-topics__topic-title', 'simple-topic-list--title')
    }, (0, _preact.h)("a", {
      className: "link link--topic",
      href: (0, _absoluteUrlRuntime.resolveUrl)((_hit$topic_url = hit.topic_url) !== null && _hit$topic_url !== void 0 ? _hit$topic_url : hit.url)
    }, _htmlParser.default.stripHtml(hit.title)), Boolean(iconClass) && (0, _preact.h)("span", {
      className: (0, _classnames.default)('icon', 'icon--replace', 'icon--round', iconClass)
    }, "icon")), hit.forum && (0, _preact.h)("a", {
      href: (0, _absoluteUrlRuntime.resolveUrl)("/fid-".concat(hit.forum)),
      className: "text--meta"
    }, hit.forum_title));
  })));
};

exports.RelatedTopicsList = RelatedTopicsList;
var RelatedTopicsListContainer = (0, _connectors.connectHits)(RelatedTopicsList);
var _default = RelatedTopicsListContainer;
exports.default = _default;